(function () {
  function parseBts26CountdownTime(value) {
    var normalized = String(value || '').trim();
    var hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized);
    if (hasTimezone) {
      var timestamp = Date.parse(normalized);
      return Number.isNaN(timestamp) ? null : new Date(timestamp);
    }

    var match = normalized.match(/^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
    if (!match) return null;
    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4] || 0),
      Number(match[5] || 0),
      Number(match[6] || 0)
    );
  }

  function padBts26Countdown(num) {
    return String(num).padStart(2, '0');
  }

  function initBts26Countdown(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll('.bts26-top-spender-countdown[data-countdown-time]').forEach(function (root) {
      if (root.getAttribute('data-countdown-inited') === '1') return;
      var target = parseBts26CountdownTime(root.getAttribute('data-countdown-time'));
      if (!target) return;
      root.setAttribute('data-countdown-inited', '1');

      function setValue(unit, value) {
        var node = root.querySelector('[data-countdown-unit="' + unit + '"]');
        if (node) node.textContent = unit === 'days' ? String(value) : padBts26Countdown(value);
      }

      function render() {
        var diff = Math.max(0, target.getTime() - Date.now());
        var total = Math.floor(diff / 1000);
        setValue('days', Math.floor(total / 86400));
        setValue('hours', Math.floor((total % 86400) / 3600));
        setValue('minutes', Math.floor((total % 3600) / 60));
        setValue('seconds', total % 60);
        if (diff <= 0) clearInterval(root._bts26CountdownTimer);
      }

      render();
      root._bts26CountdownTimer = setInterval(render, 1000);
    });
  }

  function bootBts26Countdown() {
    initBts26Countdown(document);
  }

  bootBts26Countdown();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBts26Countdown);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBts26Countdown(event.target);
  });

  window.initBts26Countdown = initBts26Countdown;
})();
